module.exports = __webpack_public_path__ + "static/peacemaker-badge-bea083a89fa270269ab1432ae28b6297.png";